import React from 'react';
import { ICON_ARRAY_LIST } from '../data/statics-datas';
import { useNavigate } from 'react-router-dom';
import useUserHook from '../controllers/useUserHook';
import { useAppDispatch } from '../store/hook';
import ModalAlert from './modal/ModalAlert';
import { openModal } from '../store/features/modalSlice';

const IconArrayList = () => {
  const { checkAndPageMove } = useUserHook();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const clickHandler = (data: any) => {
    if (data.link === undefined) {
      dispatch(
        openModal({ body: <ModalAlert message="준비중인 기능입니다." /> }),
      );
      return;
    }

    if (data.type === 'external') {
      window.open(data.link);
      return;
    }

    if (data.auth === 'USER') {
      checkAndPageMove(data.link);
    } else {
      navigate(data.link);
    }
  };
  return (
    <div className="grid grid-cols-4 gap-[19px] lg:mx-0 lg:grid-cols-8">
      {ICON_ARRAY_LIST.map((props, key) => (
        <div
          key={key}
          className="group relative flex cursor-pointer flex-col gap-1 lg:gap-[15px]"
          onClick={() => {
            clickHandler(props);
          }}
        >
          <div className="bg-gray-00 m-auto w-full rounded-[8px]">
            <img
              src={process.env.PUBLIC_URL + props.img}
              alt={props.alt}
              className="object-cover transition-transform duration-100 ease-in-out group-hover:scale-110"
            />
          </div>
          {/* 
          INFO: '내 학습\n(교사대학)' 라벨만 2줄이라 그리드 행 정렬이 틀어짐 
                → 모든 라벨 min-height를 2줄 높이로 통일  (leading-tight(1.25) 기준 2줄은 2.5em, 3em은 여유값)
          */}
          <h4 className="flex min-h-[3em] items-start justify-center whitespace-pre-line text-center text-xs font-semibold leading-tight sm:text-sm md:text-lg">
            {props.text}
          </h4>
        </div>
      ))}
    </div>
  );
};

export default IconArrayList;
